import { faker } from '@faker-js/faker'

import { TargetLanguage } from '../../contracts/service-offer'
import { AdminTreatmentPropertyStatus, AdminUnitPropertyView } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getAdminUnitPropertyView = asBuilder((): AdminUnitPropertyView => {
  const names = faker.helpers.multiple(
    () => ({
      language: faker.helpers.enumValue(TargetLanguage),
      value: faker.lorem.word(),
    }),
    { count: 3 },
  )

  return {
    id: faker.string.uuid(),
    names,
    comparisonBaseValue: faker.number.int(),
    status: faker.helpers.enumValue(AdminTreatmentPropertyStatus),
  }
})
